import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "src/app/shared/directives/user.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { Workflow } from "src/app/parametrage/core/model/workflow";
import { WorkflowService } from "src/app/parametrage/core/service/workflow.service";
import { UrlTrackingService } from 'src/app/core/services/utils/url-tracking-service';

@Component({
  selector: "app-dossier-historique",
  templateUrl: "./dossier-historique.component.html",
  styleUrls: ["./dossier-historique.component.scss"],
})
export class DossierHistoriqueComponent {
  workflowcategorie: String = "CORPORATE";
  workflows: Workflow[];
  workflow: Workflow;

  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };

  constructor(
    private userService: UserService,
    private _router: Router,
    private _workflowService: WorkflowService,
    private _keycloakService: KeycloakService,
    private _urlTrackingService: UrlTrackingService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.getWorkflowsByCategorie();
  }

  getWorkflowsByCategorie() {
    this._workflowService
      .getWorkflowsByCategorie(this.workflowcategorie)
      .subscribe(
        (data) => {
          this.workflows = data.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.workflow = this.workflows[0];
        },
        (error) => {
          console.log(error);
        }
      );
  }

  selected(workflow: Workflow) {
    this.workflow = workflow;
  }

  create(): void {
    this._router.navigate([
      this.workflow.createForm + "/" + this.workflow.code,
    ]);
  }
}
